module.exports = __webpack_public_path__ + "static/media/zw.8250d10e.svg";